import { Button, ButtonRow, PopoverConfirm } from '@timelyapp/react';
import { Checkmark } from 'components/Icons';
import { Header, HeaderGroup, HeaderRow } from 'components/ui-blocks/header';
import React from 'react';
import type useForecastBatchActions from 'routes/forecast/hooks/useForecastBatchActions';
import styles from './ForecastTableBatchActions.module.scss';

interface Props {
  isLoading: boolean;
  batchActions: ReturnType<typeof useForecastBatchActions>;
}

const ForecastTableBatchActions: React.FC<Props> = props => {
  const {
    selections,
    toggleComplete,
    toggleIncomplete,
    clearSelection,
    bulkUpdateSelections,
    bulkDeleteSelections,
    isBatchUpdating,
    isBatchDeleting,
  } = props.batchActions;

  const selectionCount = selections.forecastIds.length;

  if (!selectionCount) {
    return null;
  }

  return (
    <Header className={styles.filters} withRows sticky>
      <HeaderRow className={styles.batchActions}>
        <HeaderGroup autoGrow>
          <ButtonRow>
            <p style={{ marginRight: 5 }}>
              {selectionCount} {selectionCount > 1 ? 'tasks' : 'task'} selected
            </p>
            <Button
              isActive={selections.completedState != null && selections.completedState}
              onClick={toggleComplete}
            >
              <Checkmark />
              <span>Set as complete</span>
            </Button>
            <Button
              isActive={selections.completedState != null && !selections.completedState}
              onClick={toggleIncomplete}
            >
              <span>Set as Incomplete</span>
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              priority="xhigh"
              onClick={bulkUpdateSelections}
              className={styles.buttonSpacer}
              isLoading={isBatchUpdating}
              disabled={isBatchUpdating || isBatchDeleting}
            >
              Update
            </Button>
            <PopoverConfirm
              onConfirm={bulkDeleteSelections}
              prompt="This will delete the selected tasks"
              target={
                <Button
                  isLoading={isBatchDeleting}
                  disabled={isBatchUpdating || isBatchDeleting}
                  caret={false}
                  priority="high"
                  destructive
                >
                  Delete
                </Button>
              }
              confirmLabel="Proceed"
            />
            <Button
              disabled={isBatchUpdating || isBatchDeleting}
              priority="low"
              onClick={clearSelection}
            >
              Cancel
            </Button>
          </ButtonRow>
        </HeaderGroup>
      </HeaderRow>
    </Header>
  );
};

export default ForecastTableBatchActions;
